<template>
  <b-tabs id="tbasRsaRefertiList" ref="tbasRsaRefertiList" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
    <b-tab title="Dashboard"> <rsa-paziente-attivita-obiettivo-dashboard-component ref="cmpRsaPazienteAttivitaObiettivoDashboardComponent" /> </b-tab>
    <b-tab title="Obiettivi">
      <rsa-paziente-attivita-obiettivi-obiettivi-component ref="cmpRsaPazienteAttivitaObiettiviObiettiviComponent" />
    </b-tab>
  </b-tabs>
</template>

<script>
import RsaPazienteAttivitaObiettiviObiettiviComponent from "./RsaPazienteAttivitaObiettiviObiettiviComponent.vue";
import RsaPazienteAttivitaObiettivoDashboardComponent from "./RsaPazienteAttivitaObiettivoDashboardComponent.vue";

export default {
  props: {
    idAccettazione: { type: String },
  },
  components: { RsaPazienteAttivitaObiettivoDashboardComponent, RsaPazienteAttivitaObiettiviObiettiviComponent },
  data() {
    return {
      activeTabIndex: 0,
    };
  },
  mounted() {},
  methods: {
    loadData(index) {
      switch (index) {
        case 0:
          this.$refs.cmpRsaPazienteAttivitaObiettivoDashboardComponent.defaultLoading();
          break;
        case 1:
          this.$refs.cmpRsaPazienteAttivitaObiettiviObiettiviComponent.loadData();
          break;
        default:
          break;
      }
    },
    onInputTabs(index) {
      this.loadData(index);
    },
    onClickNuovo() {
      let me = this;
      me.$refs.cmpRsaPazienteArmadiettoRicevuteModalEdit.openModal(me.idAccettazione);
    },
    onSaveSuccess() {
      let me = this;
      me.loadData(1);
    },
  },
};
</script>

<style></style>
